import React, { useState } from 'react';

const DashboardCardComponent = ({
                           title,
                           children,
                           variant = 'default',
                           size = 'medium',
                           className = '',
                           headerAction,
                           footer,
                           gradient = false,
                           shadow = true,
                           padding = 'normal',
                           onClick
                       }) => {
    const [isHovered, setIsHovered] = useState(false);

    const baseClasses = `
    bg-white rounded-xl transition-all duration-200 
    ${shadow ? 'shadow-lg hover:shadow-xl' : ''}
    ${onClick ? 'cursor-pointer' : ''}
    ${gradient ? 'bg-gradient-to-br from-white to-gray-50' : ''}
    ${className}
  `;

    const sizeClasses = {
        small: 'min-h-[120px]',
        medium: 'min-h-[200px]',
        large: 'min-h-[300px]',
        auto: 'min-h-fit'
    };

    const paddingClasses = {
        none: 'p-0',
        small: 'p-3',
        normal: 'p-6',
        large: 'p-8'
    };

    const variantClasses = {
        default: 'border border-gray-100',
        primary: 'border-2 border-green-200 bg-green-50',
        warning: 'border-2 border-yellow-200 bg-yellow-50',
        danger: 'border-2 border-red-200 bg-red-50',
        info: 'border-2 border-blue-200 bg-blue-50',
        success: 'border-2 border-green-200 bg-green-50'
    };

    return (
        <div
            className={`${baseClasses} ${sizeClasses[size]} ${paddingClasses[padding]} ${variantClasses[variant]}`}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                transform: isHovered && onClick ? 'translateY(-2px)' : 'translateY(0)'
            }}
        >
            {title && (
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold text-gray-800">{title}</h3>
                    {headerAction && (
                        <div className="text-sm">{headerAction}</div>
                    )}
                </div>
            )}

            <div className="flex-1">
                {children}
            </div>

            {footer && (
                <div className="mt-4 pt-4 border-t border-gray-100">
                    {footer}
                </div>
            )}
        </div>
    );
};

export default DashboardCardComponent;